import { Link } from 'react-router-dom';
import { BRAND_NAME, BRAND_SLOGAN } from '@/mocks/categories';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综艺', to: '/category/variety' },
  { label: '纪录片', to: '/category/documentary' },
];

const supportLinks = [
  { label: '搜索资源', to: '/search' },
  { label: '关于我们', to: '/about' },
  { label: '联系我们', to: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100 mt-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2">
            <span className="w-9 h-9 rounded-md bg-accent-500 text-background-50 flex items-center justify-center">
              <i className="ri-film-line text-xl"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">{BRAND_NAME}</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-md">{BRAND_SLOGAN}</p>
          <p className="mt-3 text-sm text-background-300 max-w-md">
            本站为影音资源展示与导航平台，播放链接仅作界面演示，不具备真实播放能力。
          </p>
        </div>

        <div>
          <h4 className="text-background-50 font-semibold mb-3">
            <Link to="/">快速导航</Link>
          </h4>
          <ul className="space-y-2 text-sm">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-background-300 hover:text-accent-400 transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-background-50 font-semibold mb-3">
            <Link to="/about">帮助与支持</Link>
          </h4>
          <ul className="space-y-2 text-sm">
            {supportLinks.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="text-background-300 hover:text-accent-400 transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
          <p className="mt-4 text-sm text-background-300 flex items-center gap-2">
            <i className="ri-mail-line"></i>
            service@gyyy-resource.cn
          </p>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="max-w-[1280px] mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-background-400">
          <p>© {new Date().getFullYear()} {BRAND_NAME}. 保留所有权利。</p>
          <p>本站内容仅用于信息展示与学习交流，请支持正版影视作品。</p>
        </div>
      </div>
    </footer>
  );
}